export function searching(payload) {
  return { 
    type: 'SEARCH',
    payload,
  }
}